exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fontBold[data-v-777dcf1a] {\n\tfont-weight: bolder;\n}\n", ""]);

// exports
